import React, { ReactNode } from "react";
import styles from "../TherapistSteps.module.scss";
import cn from "classnames";

export const TherapistStepsGrid = ({ children, className }: { children: ReactNode | string; className?: string }) => (
  <div className={cn(styles.grid, className)}>{children}</div>
)
